export default "__VITE_ASSET__bc1165f9__"